export function isSameOriginUrl(url: string, pageOrigin: string): boolean {
	try {
		return new URL(url, pageOrigin).origin === pageOrigin;
	} catch {
		return false;
	}
}
